import { render, staticRenderFns } from "./ExamWithdrawal.vue?vue&type=template&id=58ed5d0a&scoped=true"
import script from "./ExamWithdrawal.vue?vue&type=script&lang=js"
export * from "./ExamWithdrawal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ed5d0a",
  null
  
)

export default component.exports